<template>
  <div class="cardy-body-noBorder mt-3">
    <div class="mb-3 col-lg-12 col-xs-12">
      <h4 class="color-dark-purple mt-3">
        <strong>ADICIONAR UM ARQUIVO</strong>
      </h4>
    </div>
    <div class="row">
      <div class="col-xs-12 col-lg-2">
        <div class="btn-add-items-tb bg-purple center">
          <label class="f20 color-white pointer p-0">
            <span class="pointer">
              <i class="fas fa-upload ml-1 mr-1"></i>
              <input
                type="file"
                ref="file"
                class="btn-add-items-tb bg-purple"
                style="display: none; width: 100%"
                name="fileUpload"
                multiple
                @change="setName"
              />
              <span>UPLOAD</span>
            </span>
          </label>
        </div>
      </div>
      <div class="col-lg-8 col-xs-12 d-flex align-items-center">
        <span>{{ this.showName }}</span>
      </div>
      <div class="col-xs-12 mt-2 mb-2 col-lg-12 cardy-body-noBorder">
        <span class="ml-2">DESCRIÇÃO</span>
      </div>
      <div class="col-lg-12 col-xs-12">
        <textarea
          class="full form-control"
          cols="30"
          rows="10"
          style="height: 100px"
          v-model="files.description"
        ></textarea>
      </div>
      <div class="col-lg-9"></div>
      <div class="col-lg-3 col-xs-12 mt-3 mb-2">
        <button
          style="width: 100%"
          class="color-white btn-add-items-tb bg-purple"
          @click="sendFile"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
  <!-- 
  <div id="form-file" class="card p-3" style="border-radius: 10px">
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <span class="f20">DESEJA FAZER UPLOAD DE ALGUM ARQUIVO ? </span>
        <label class="f20 color-primary pointer p-0">
          <span class="pointer">
            <i class="fas fa-paperclip ml-1 mr-1"></i>
            <input
              type="file"
              ref="file"
              style="display: none"
              name="fileUpload"
              multiple
              @change="setName"
            />
          </span>
        </label>
        <div v-show="showName != ''">
          <span>Arquivo selecionado: {{ this.showName }}</span>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <textarea
          class="full f18 form-control"
          cols="30"
          rows="10"
          placeholder=" FAÇA AQUI UMA BREVE DESCRIÇÃO"
          style="height: 100px; border-radius: 5px"
          v-model="files.description"
        ></textarea>
      </div>
      <div class="col-lg-12 col-xs-12">
        <button
          class="btn btn-primary p-2 mt-1 bnt-pattern-tb"
          style="float: right"
          @click="sendFile"
        >
          <i class="fas fa-upload"></i>
          UPLOAD
        </button>
      </div>
    </div>
  </div> -->
</template>
<script>
export default {
  props: ["candidate"],
  data: () => ({
    files: {
      name: "",
      description: "",
    },
    file: "",
    showName: "",
  }),
  methods: {
    setName() {
      this.showName = this.$refs.file.files[0].name;
    },
    async sendFile() {
      this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("files[file]", this.file);
      formData.append("files[name]", this.file.name);
      formData.append("files[description]", this.files.description);

      await axios
        .post(
          `/recruiters/talent_banks/${this.candidate.id}/candidate/file`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            eventBus.$emit("getFiles");
            this.$toast.success("Arquivo Adicionado com sucesso");
            this.$emit("close");
            return;
          }
          this.$toast.error("Não foi possivel realizar o upload do arquivo");
        });
    },
  },
};
</script>